/* global FileReader */
import md5 from 'md5';
import { read, utils } from 'xlsx';

const EMAIL_ALIASES = ['email', 'e-mail', 'email address', 'email_address', 'emailaddress'];
const PHONE_ALIASES = ['phone', 'cell', 'mobile', 'cell_phone', 'cellphone', 'phone_number', 'phonenumber', 'cell phone number', 'mobile phone number', 'mobile number', 'phone number'];

export const SUPPORTED_EXTENSIONS = ['csv', 'txt', 'xlsx'];

export const EXPORT_FORMAT_OPTIONS = [
  { value: 'csv', label: 'CSV', mimeType: 'text/csv' },
  { value: 'txt', label: 'TXT', mimeType: 'text/plain' },
  {
    value: 'xlsx',
    label: 'XLSX',
    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  },
];

export function getFileExtension(filename) {
  return filename.slice(filename.lastIndexOf('.') + 1).toLowerCase();
}

export function normalizePhone(raw) {
  if (!raw) return null;
  let digits = raw.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }
  if (digits.length !== 10) return null;
  return digits;
}

export function hashValue(value) {
  return md5(value);
}

export function generateHashListText(hashes, dataType) {
  const unique = [...new Set(hashes)];
  return `${dataType}\n${unique.join('\n')}\n`;
}

export function getOutputFilename(exportMode, dataType, originalFilename, format, dateString) {
  if (exportMode === 'merge') {
    return `hashed_${dataType}_${dateString}.${format}`;
  }
  const stripExtension = new RegExp(`\\.(${SUPPORTED_EXTENSIONS.join('|')})$`, 'i');
  const base = originalFilename.replace(stripExtension, '');
  return `${base}_hashed_${dataType}_${dateString}.${format}`;
}

export function autoDetectColumn(columns, dataType) {
  const aliases = dataType === 'email' ? EMAIL_ALIASES : PHONE_ALIASES;
  return columns.find((col) => typeof col === 'string' && aliases.includes(col.toLowerCase())) ?? null;
}

function readAsArrayBuffer(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Could not read file'));
    reader.readAsArrayBuffer(file);
  });
}

export async function readXlsxFirstSheetHeader(file) {
  const buf = await readAsArrayBuffer(file);
  const workbook = read(buf, { type: 'array', sheetRows: 1 });
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  const [header] = utils.sheet_to_json(sheet, { header: 1 });
  return header || [];
}
